import classNames from "classnames/bind";
import * as React from "react";

import CarouselSwiper from "../Carousel/CarouselSwiper";
import CarouselContainer from "../Carousel/CarouselContainer";

import Card from "./Card";
import Overview from "./Overview";

import styles from "./Testimonials.module.scss";
import UIIcon from "../UIIcon";
import useReviews from "./useReviews";
import type { ResolvedTestimonials } from "resolvers/data/testimonialsResolver";
import type { ResolvedReview } from "resolvers/data/trustpilotResolver";

const cx = classNames.bind(styles);

const NavigationButton: React.FC<any> = ({ id, direction, ariaLabel, ...rest }) => (
    <button
        className={cx("navButton")}
        id={`${direction}Button${id}`}
        aria-label={ariaLabel}
        {...rest}
    >
        <UIIcon icon={direction === "prev" ? "ChevronLeft" : "ChevronRight"} />
    </button>
);

const Testimonials: React.FC<ResolvedTestimonials> = ({ sectionName, heading, logo }) => {
    const { isSuccess, data } = useReviews();

    if (!isSuccess || !data) return null;

    const { overview, reviews } = data;

    return (
        <div className={cx("sectionContainer")}>
            <div className={cx("container")}>
                <h2 className={cx("heading")}>{sectionName}</h2>
                <Overview {...overview} heading={heading} logo={logo} />
            </div>

            <div className={cx("reviews")}>
                <NavigationButton
                    id="testimonials"
                    direction="prev"
                    ariaLabel="Carousel previous"
                    disabled
                />
                <CarouselContainer>
                    <CarouselSwiper id="testimonials">
                        {reviews.map((review: ResolvedReview) => (
                            <Card key={review.id} {...review} />
                        ))}
                    </CarouselSwiper>
                </CarouselContainer>
                <NavigationButton id="testimonials" direction="next" ariaLabel="Carousel next" />
            </div>
        </div>
    );
};

export default Testimonials;
